const LICENCE_KEY = import.meta.env.VITE_CK_EDITOR_LICENCE_KEY;
const TOKEN_URL = import.meta.env.VITE_CK_EDITOR_TOKEN_URL;
const WEBSOCKET_URL = import.meta.env.VITE_CK_EDITOR_WEBSOCKET_URL;
const UPLOAD_URL = import.meta.env.VITE_CK_EDITOR_UPLOAD_URL;

const dateFormatOptionsList = [
  {
    value: 1,
    label: 'mm.dd.yyyy',
    format: 'MM.DD.YYYY',
  },
  {
    value: 2,
    label: 'dd.mm.yyyy',
    format: 'DD.MM.YYYY',
  },
  {
    value: 3,
    label: 'mm/dd/yyyy',
    format: 'MM/DD/YYYY',
  },
  {
    value: 4,
    label: 'dd/mm/yyyy',
    format: 'DD/MM/YYYY',
  },
  {
    value: 5,
    label: 'mm-dd-yyyy',
    format: 'MM-DD-YYYY',
  },
  {
    value: 6,
    label: 'dd-mm-yyyy',
    format: 'DD-MM-YYYY',
  },
  {
    value: 7,
    label: 'yyyy-mm-dd',
    format: 'YYYY-MM-DD',
  },
];

const timeFormatOptionsList = [
  {
    value: 8,
    label: 'hh:mm',
    format: 'HH:mm',
  },
  {
    value: 9,
    label: 'hh:mm:ss',
    format: 'HH:mm:ss',
  },
  {
    value: 11,
    label: 'hh:mm:ss A',
    format: 'hh:mm:ss A',
  },
];

const getFormattedDate = (val, format) => {
  if (val) {
    const date = val.split('-');
    const year = date[0];
    const month = date[1];
    const day = date[2];
    const hour = date[3];
    const minute = date[4];
    const second = date[5];
    const millisecond = date[6] || '';
    const hourNum = parseInt(hour, 10);
    const periodUpper = hourNum >= 12 ? 'PM' : 'AM';
    const periodLower = periodUpper.toLowerCase();
    const hour12 = String(hourNum % 12 || 12).padStart(2, '0');
    const dateFormatMapper = {
      'mm.dd.yyyy': `${month}.${day}.${year}`,
      'dd.mm.yyyy': `${day}.${month}.${year}`,
      'mm/dd/yyyy': `${month}/${day}/${year}`,
      'dd/mm/yyyy': `${day}/${month}/${year}`,
      'mm-dd-yyyy': `${month}-${day}-${year}`,
      'dd-mm-yyyy': `${day}-${month}-${year}`,
      'yyyy-mm-dd': `${year}-${month}-${day}`,
      'hh:mm': `${hour}:${minute}`,
      'hh:mm:ss': `${hour}:${minute}:${second}`,
      'hh:mm:ss.sss': `${hour}:${minute}:${second}.${millisecond}`,
      'hh:mm:ss A': `${hour12}:${minute}:${second} ${periodUpper}`,
      'hh:mm:ss a': `${hour12}:${minute}:${second} ${periodLower}`,
    };

    return dateFormatMapper[format];
  }
};

const supportedColumnsFromMonday = [
  'date',
  'long_text',
  'text',
  'location',
  'numbers',
  'item_id',
  'phone',
  'email',
  'mirror',
  'formula',
  'status',
  'dropdown',
  'board_relation',
  'file',
  'link',
  'people',
];

const ckEditorBoardFields = [
  'date',
  'long_text',
  'text',
  'location',
  'numbers',
  'item_id',
  'phone',
  'email',
  'mirror',
  'formula',
  'status',
  'dropdown',
  'board_relation',
  // 'file',
  'link',
  'people',
];

const CKEDITOR_COLOR_OPTIONS = [
  {
    color: '#000000',
    label: 'Black',
  },
  {
    color: '#FFFFFF',
    label: 'White',
  },
  {
    color: '#808080',
    label: 'Grey',
  },
  {
    color: '#FF0000',
    label: 'Red',
  },
  {
    color: '#FFA500',
    label: 'Orange',
  },
  {
    color: '#FFFF00',
    label: 'Yellow',
  },
  {
    color: '#0000FF',
    label: 'Blue',
  },
  {
    color: '#008000',
    label: 'Green',
  },
];

const ckEditorCss = `
    .table {
      float: left;
    }

    .table table {
      border: 1px solid black !important;
      border-collapse: collapse; 
      border-spacing: 0; 
    }

    .table table td {
      text-align: center;
      vertical-align: bottom;
      padding: 10px;
      border: 1px solid black !important;
    }
    
    ul,ol {
      line-height: 1.4;
    };
    
    ul {
      list-style-type: disc;
    }

    ul ul {
      list-style-type: circle;
    }

    ul ul ul {
      list-style-type: square;
    }

    ol {
        list-style-type: decimal;
    }

    ol ol {
        list-style-type: lower-alpha;
    }

    ol ol ol {
        list-style-type: lower-roman;
    }

    .marker-yellow {
      background-color: #ffff00; /* Highlight color */
      padding: 0 2px;
      border-radius: 2px;
    }
`;

const CK_SUBITEM_EVENTS = {
  create: 'create',
  edit: 'edit',
  delete: 'delete',
  undoRedo: 'undoRedo',
};

const CK_MONDAY_TAG_EVENTS = {
  MONDAY_TAG_INSERTED: 'mondayTagInserted', // USED TO HANDLE INSERT EVENTS FROM  CKEDITOR's UNDO EVENT
  MONDAY_TAG_CLICKED: 'mondayTagClicked',
  MONDAY_TAG_DELETED: 'mondayTagDeleted',
  MONDAY_TAG_COPIED: 'mondayTagCopied',
  MONDAY_TAG_CUT: 'mondayTagCut',
  DISALLOWED_EVENTS: 'disallowedEvents',
  MULTIPLE_TAGS_SELECTED: 'multipleTagsSelected',
};

export {
  TOKEN_URL,
  UPLOAD_URL,
  LICENCE_KEY,
  ckEditorCss,
  WEBSOCKET_URL,
  CKEDITOR_COLOR_OPTIONS,
  ckEditorBoardFields,
  dateFormatOptionsList,
  timeFormatOptionsList,
  supportedColumnsFromMonday,
  getFormattedDate,
  CK_SUBITEM_EVENTS,
  CK_MONDAY_TAG_EVENTS,
};
